

export class AutoCompleteModel {
      url: string;
      searchKey: string;
      minSearchLength?= 3;
      placeholder?= '';
}



// WEBPACK FOOTER //
// ./src/app/components/auto-complete/auto-complete.model.ts